import PreventActionsScreen from './PreventActionsScreen';

export default PreventActionsScreen;
